module.exports = __webpack_public_path__ + "img/iconPark-trend-two.e0ff0366.svg";